import CalendarEventsStoreIndex from './schema/CalendarEventsStoreIndex';
import { CalendarEvent } from 'mini-calendar-event-types';

export default class CalendarEventsStore {
    private itemIdEventMap: Map<string, CalendarEvent>;
    private storeIndexes: CalendarEventsStoreIndex[];

    constructor() {
        this.itemIdEventMap = new Map<string, CalendarEvent>();
        this.storeIndexes = [];
    }

    addIndex(index: CalendarEventsStoreIndex) {
        this.storeIndexes.push(index);
    }

    getCalendarEvent(itemId: string): CalendarEvent {
        return this.itemIdEventMap.get(itemId);
    }

    addCalendarEvent(event: CalendarEvent) {
        event && this.itemIdEventMap.set(event.ItemId.Id, event);
        this.storeIndexes.forEach(index => index.onAddCalendarEvent(event));
    }

    deleteCalendarEvent(event: CalendarEvent) {
        this.storeIndexes.forEach(index => index.onDeleteCalendarEvent(event));
        // This delete should be later as onDeleteCalendarEvent internally has a flow which depends on
        // itemIdEventMap
        event && this.itemIdEventMap.delete(event.ItemId.Id);
    }

    deleteCalendarEventByItemId(itemId: string) {
        const event = this.getCalendarEvent(itemId);

        this.storeIndexes.forEach(index => index.onDeleteCalendarEvent(event));
        this.itemIdEventMap.delete(itemId);
    }

    getCalendarEvents(itemIds: string[]): CalendarEvent[] {
        return itemIds.map(itemId => this.itemIdEventMap.get(itemId));
    }

    addCalendarEvents(events: CalendarEvent[]) {
        events.forEach(event => this.addCalendarEvent(event));
    }

    deleteCalendarEvents(events: CalendarEvent[]) {
        events.forEach(event => this.deleteCalendarEvent(event));
    }

    deleteCalendarEventsForItemIds(itemIds: string[]) {
        itemIds.forEach(itemId => this.deleteCalendarEventByItemId(itemId));
    }

    clearStore() {
        this.itemIdEventMap = new Map<string, CalendarEvent>();
        this.storeIndexes.forEach(index => index.clearIndex());
    }
}
